import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { Counter } from "@/components/Counter";
import { TRAYECTORIA } from "@/data/content";

export const Trayectoria = () => {
  return (
    <section
      id="trayectoria"
      data-testid="trayectoria-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="pointer-events-none absolute top-1/2 -right-40 w-[40vw] h-[40vw] bg-[#E60000] opacity-[0.12] blur-[140px] rounded-full" />

      <div className="max-w-7xl mx-auto relative">
        <Reveal className="max-w-3xl">
          <p className="text-sm font-bold text-[#E60000] tracking-[0.2em] uppercase mb-6">
            {TRAYECTORIA.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
            {TRAYECTORIA.title}
          </h2>
          <p className="text-lg font-light text-[#A3A3A3] leading-relaxed mt-8">
            {TRAYECTORIA.description}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mt-20">
          {TRAYECTORIA.metrics.map((metric, i) => (
            <Reveal key={metric.label} delay={i * 0.12} testId={`metric-${i}`}>
              <div className="text-6xl md:text-8xl font-black text-[#E60000] tracking-tighter leading-none">
                <Counter value={metric.value} suffix={metric.suffix} testId={`counter-${i}`} />
              </div>
              <div className="text-sm font-bold text-white uppercase tracking-[0.2em] mt-5">
                {metric.label}
              </div>
              <p className="text-[#A3A3A3] leading-relaxed mt-4 max-w-xs">{metric.detail}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-24 pt-16 border-t border-white/10">
          <h3 className="text-sm font-bold text-[#A3A3A3] uppercase tracking-[0.2em] mb-10">
            {TRAYECTORIA.clientsTitle}
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
            {TRAYECTORIA.clients.map((client, i) => (
              <motion.div
                key={client.name}
                data-testid={`client-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                whileHover={{ y: -6 }}
                className="bg-white aspect-[4/3] flex items-center justify-center p-6 overflow-hidden group"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-16 md:max-h-20 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                />
              </motion.div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Trayectoria;
